module.exports = __webpack_public_path__ + "media/country_flags/pg-e1702a55.png";